module.exports = __webpack_public_path__ + "static/alert-link-dont-cf2ce24552ed78c642de3c429c9b3b29.png";